import {init as prompt} from './modules/prompt'
import {init as arrow} from './modules/arrow/prompt'

export {
	prompt,
	arrow,
}



// WEBPACK FOOTER //
// ./home/node/site/newtab/index.js